import { useTranslation } from 'react-i18next';

interface PageLoaderProps {
  /** Catalogue key for the wait being shown; defaults to the generic one. */
  messageKey?: string;
}

/**
 * Full-height wait screen. Exists so the router's `Suspense` fallbacks can show
 * a translated message — a fallback is written in a module-level config array,
 * where a hook cannot be called.
 */
export const PageLoader = ({ messageKey = 'common.loading' }: PageLoaderProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex h-screen w-full items-center justify-center">
      <div className="text-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary mx-auto mb-2" />
        <p>{t(messageKey)}</p>
      </div>
    </div>
  );
};
